import React, { Component, Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
// import Header from "../Header";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";
import { list as industryList } from "../../../services/industry";
import { list as jobDurationList } from "../../../services/jobDuration";
import { list as jobCategoryList } from "../../../services/jobCategory";
import { list as typeList } from "../../../services/jobType";
import { create as addCard } from "../../../services/card";
import { use as addCoupon } from "../../../services/coupon";
import { create } from "../../../services/employerJobListing";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import AppContext from "../../../contexts/AppContext";
import Card from "./Card";
import Coupon from "./Coupon";
import Pay from "./Pay";
import PaymentCompleted from "./PaymentCompleted";

export class JobCreate extends Component {
    state = {
        item: {},
        meta:{},
        errors: {},
        state: "",
        industryList: [],
        jobCategoryList: [],
        typeList: [],
        jobDurationList: [],
        card: [],
        needPayment: false,
        needCard: false,
        paymentCompleted: false,
        needCoupon: false,
        plan_desc: '',
        plan_price: 0,
        togglePadding: 'mt-3'
    };

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.description = value;

        let error = this.state.errors;
        error.description = null;

        this.setState({ item: temp, errors: error });
    };

    handleIndustrySelectChange = selectedOption => {
        let temp = this.state.item;
        temp.industry_id = selectedOption.value;

        let error = this.state.errors;
        error.industry_id = null;

        this.setState({ item: temp, errors: error });
    };

    handleCategorySelectChange = selectedOption => {
        let temp = this.state.item;
        temp.category_id = selectedOption.value;

        let error = this.state.errors;
        error.category_id = null;

        this.setState({ item: temp, errors: error });
    };

    handleDurationSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.duration_id = selectedOption.value;

        let error = this.state.errors;
        error.duration_id = null;
        this.setState({ item: temp, errors: error });
    };

    handleTypeSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.type_id = selectedOption.value;

        let error = this.state.errors;
        error.type_id = null;

        this.setState({ item: temp, errors: error });
    };

    handleSubmitJob = type => {
        create({ state: type, ...this.state.item })
            .then(response => {
               
                this.context.state.updateUserPlan(response.meta.plan);
                this.context.state.setCoupon({});
                this.props.history.push("/employer/jobListing");
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    case 402:
                        this.setState({
                            needPayment: true,
                            needCard: false,
                            plan_desc: errors.response.data.meta.description,
                            plan_price: errors.response.data.meta.price,
                        });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });
    };

    componentDidMount() {
        if(this.context.state.user.email_verified === 'false') {
            this.setState({togglePadding: 'mt-15'});
          }
        industryList()
            .then(res => {
                this.setState({ industryList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        jobCategoryList()
            .then(res => {
                this.setState({ jobCategoryList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        typeList()
            .then(res => {
                this.setState({ typeList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        jobDurationList()
            .then(res => {
                this.setState({ jobDurationList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    addCard = item => {
        return addCard(item).then(response => {
            this.setState({
                needPayment: true,
                needCard: false
            });
        });
    };

    addCoupon = item => {
        return addCoupon(item).then(response => {
            this.setState({
                needPayment: true,
                needCoupon: false
            });
            this.context.state.setCoupon(response.data);
        });
    };

    hideAll = () => {
        this.setState({
            needPayment: false,
            needCard: false,
            needCoupon: false,
            paymentCompleted: false
        });
    };

    showAddCard = () => {
        this.setState({
            needPayment: false,
            needCard: true
        });
    };
    showAddCoupon = () => {
        this.setState({
            needPayment: false,
            needCoupon: true
        });
    };
    showPaymentSuccess = () => {
        this.setState({
            needPayment: false,
            needCard: false,
            paymentCompleted: true
        });
    };
    render() {
        const user = this.state.meta;
        return (
            <Fragment>
                <Header />
                {/* <section className="dashboard-nav">
		                <div className="container employer-container">
		            	    <div className="head">
		            		    <h1 className="text-white">Welcome back,  { user.first_name }!</h1>
		            			<h2>Let's find you some great writers.</h2>
		            		</div>
							<AccountNav></AccountNav>
		            	</div>
		        </section> */}
                {this.state.needCard === true ? (
                    <Card hideCard={this.hideAll} addCard={this.addCard}></Card>
                ) : null}

                {this.state.needCoupon === true ? (
                    <Coupon
                        hideCoupon={this.hideAll}
                        addCoupon={this.addCoupon}
                    ></Coupon>
                ) : null}

                {this.state.needPayment === true ? (
                    <Pay
                        showAddCard={this.showAddCard}
                        showAddCoupon={this.showAddCoupon}
                        showPaymentSuccess={this.showPaymentSuccess}
                        hidePay={this.hideAll}
                        planDesc={this.state.plan_desc}
                        planPrice={this.state.plan_price}
                    ></Pay>
                ) : null}

                {this.state.paymentCompleted === true ? (
                    <PaymentCompleted hidePay={this.hideAll}></PaymentCompleted>
                ) : null}

                <div className={`main-content pt-20  ${this.state.togglePadding}`}>
                    <div className="employer-container container m-auto mt-3">
                        <div className="row justify-content-center">
                            <div
                                id="formModal"
                                className="col-12 col-md-12 col-lg-12 col-xl-12"
                            >
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h6 className="header-pretitle">
                                                    New job listing
                                                </h6>
                                                <h1 className="header-title">
                                                    Publish a new job listing
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form data-select2-id="14">
                                    <div className="form-group">
                                        <label htmlFor="title">Title</label>
                                        <input
                                            id="title"
                                            name="title"
                                            onChange={this.onChange}
                                            value={this.state.item.title}
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.title ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.title}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-6">
                                        <label
                                            className="mb-1"
                                            htmlFor="description"
                                        >
                                            Description
                                        </label>
                                        <small className="form-text text-muted">
                                            please enter full details about job
                                            description
                                        </small>
                                        <Quill
                                            style={{
                                                height: "200px"
                                            }}
                                            onChange={this.handleQuillChange}
                                            theme="snow"
                                        ></Quill>

                                        {this.state.errors.description ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.description}
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-12 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="payout">
                                                    Ave. Per-Article Payout
                                                    (USD)
                                                </label>
                                                <input
                                                    id="payout"
                                                    name="payout"
                                                    onChange={this.onChange}
                                                    type="number"
                                                    value={
                                                        this.state.item.payout
                                                    }
                                                    className="form-control"
                                                />
                                                {this.state.errors.payout ? (
                                                    <div className="invalid-feedback">
                                                        {
                                                            this.state.errors
                                                                .payout
                                                        }
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="word_count">
                                                    Ave. Words Per Article
                                                </label>
                                                <input
                                                    name="word_count"
                                                    id="word_count"
                                                    onChange={this.onChange}
                                                    value={
                                                        this.state.item
                                                            .word_count
                                                    }
                                                    type="number"
                                                    className="form-control"
                                                />
                                                {this.state.errors
                                                    .word_count ? (
                                                    <div className="invalid-feedback">
                                                        {
                                                            this.state.errors
                                                                .word_count
                                                        }
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" data-select2-id="13">
                                        <div
                                            className=" col-sm-6 form-group m-form__group"
                                            data-select2-id="12"
                                        >
                                            <label>Industry</label>
                                            <Select
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="industry_id"
                                                onChange={
                                                    this
                                                        .handleIndustrySelectChange
                                                }
                                                options={
                                                    this.state.industryList
                                                }
                                            ></Select>
                                            {this.state.errors.industry_id ? (
                                                <div className="invalid-feedback">
                                                    The industry field is
                                                    required.
                                                </div>
                                            ) : null}
                                        </div>

                                        <div
                                            className="col-sm-6 form-group m-form__group"
                                            data-select2-id="84"
                                        >
                                            <label>Relationship Type</label>
                                            <Select
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="category_id"
                                                onChange={
                                                    this
                                                        .handleCategorySelectChange
                                                }
                                                options={
                                                    this.state.jobCategoryList
                                                }
                                            ></Select>
                                            {this.state.errors.category_id ? (
                                                <div className="invalid-feedback">
                                                    The relationship type field
                                                    is required.
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-sm-6 form-group m-form__group"
                                            data-select2-id="101"
                                        >
                                            <label>Type</label>
                                            <Select
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="type_id"
                                                onChange={
                                                    this.handleTypeSelectChange
                                                }
                                                options={this.state.typeList}
                                            ></Select>
                                            {this.state.errors.type_id ? (
                                                <div className="invalid-feedback">
                                                    The type field is required.
                                                </div>
                                            ) : null}
                                        </div>
                                        <div
                                            className="col-sm-6 form-group m-form__group"
                                            data-select2-id="94"
                                        >
                                            <label>Duration</label>
                                            <Select
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="duration_id"
                                                onChange={
                                                    this
                                                        .handleDurationSelectChange
                                                }
                                                options={
                                                    this.state.jobDurationList
                                                }
                                            ></Select>
                                            {this.state.errors.duration_id ? (
                                                <div className="invalid-feedback">
                                                    The duration field is
                                                    required.
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="form-group col-sm-12">
                                            <label htmlFor="spots">
                                                Spots Available
                                            </label>
                                            <input
                                                type="text"
                                                id="spots"
                                                value={this.state.item.spots}
                                                name="spots"
                                                onChange={this.onChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <hr className="mt-5 mb-5" />
                                    {/* <h2 className="mb-2">
                                        {this.context.state.user.plan.name}:
                                        <span className="badge badge-soft-primary ml-1 mt-n1">
                                            {this.context.state.user.plan
                                                .price === 0
                                                ? `Free`
                                                : `$` +
                                                  this.context.state.user.plan
                                                      .price}
                                        </span>
                                    </h2> */}
                                    {/* <p className="text-muted mb-2  smaller-text">
                                        Visible for{" "}
                                        {this.context.state.user.plan.days} days
                                    </p> */}
                                    <p className="text-muted mb-4  smaller-text">
                                        You will receive and manage the writer
                                        applications through your ProWriter
                                        account.
                                    </p>
                                    <a
                                        onClick={() =>
                                            this.handleSubmitJob("active")
                                        }
                                        name="save"
                                        className="newJob btn btn-block btn-primary text-white"
                                    >
                                        Post job listing
                                    </a>
                                    <div className=" btn-block center-text  mb-4 mt-3 d-flex justify-content-center">
                                        <Link
                                            to={`/employer/jobListing`}
                                            className="btn btn-link text-muted"
                                        >
                                            Cancel this job
                                        </Link>
                                        <a
                                            onClick={() =>
                                                this.handleSubmitJob("saved")
                                            }
                                            className="btn btn-link text-muted"
                                        >
                                            Save as draft
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

JobCreate.contextType = AppContext;
export default JobCreate;



// WEBPACK FOOTER //
// ./src/components/employer/jobListing/Create.js